<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <h1 class="modal-title">Choose your payment method</h1>
      <select-field
        v-model="paymentMethod"
        :items="paymentOptions"
        label="Payment Type"
        item-render="display"
        item-select="value"
        @change="calculateOrderTotalPrice"
      />
      <p>
        Customer should pay: <b>{{ totalPrice }} EUR</b>
      </p>
      <text-field
        v-model="buyerEmail"
        label="Buyer's mail (optional)"
        hint="By adding the buyer's email, there will be a chance for CoreEvent to get in touch
          with the buyer in case of any changes"
        persistent-hint
        :validator="$v.buyerEmail"
        style="margin-bottom: 1rem"
      >
        <template v-slot:prepend-inner>
          <img src="/assets/mail-icon.svg" alt="mail-icon" class="mail-icon">
        </template>
      </text-field>
      <div class="buttons">
        <div class="buttons-right">
          <main-button class="back-btn" flat :text="'CANCEL'" @click="$emit('closeModal')" />
          <main-button class="continue-btn" depressed @click="submit">
            <span>Continue</span>
          </main-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { email } from 'vuelidate/lib/validators'
import { round } from 'lodash'

export default {
  name: 'payment-type-modal',
  props: { orderTotalPrice: Number },
  validations() {
    return {
      buyerEmail: { email },
    }
  },
  data() {
    return {
      paymentMethod: 'CASH',
      paymentOptions: [
        {
          display: 'Cash',
          value: 'CASH',
        },
        {
          display: 'Card',
          value: 'CARD',
        },
        {
          display: 'Other',
          value: 'OTHER',
        },
        {
          display: 'Gratis',
          value: 'FREE',
        },
        {
          display: 'KEKS - 10%',
          value: 'KEKS10',
        },
        {
          display: 'TELEGRAM - 20%',
          value: 'TELEGRAM20',
        },
      ],
      buyerEmail: null,
      totalPrice: this.orderTotalPrice,
    }
  },
  methods: {
    submit() {
      this.$v.buyerEmail.$touch()
      if (!this.$v.buyerEmail.$invalid) {
        this.$emit('submit', this.paymentMethod, this.buyerEmail)
      }
    },
    calculateOrderTotalPrice() {
      let newPrice = Number(this.orderTotalPrice)
      if (this.paymentMethod === 'KEKS10') {
        newPrice = round(this.orderTotalPrice * 0.9, 2)
      } else if (this.paymentMethod === 'TELEGRAM20') {
        newPrice = round(this.orderTotalPrice * 0.8, 2)
      } else if (this.paymentMethod === 'FREE') {
        newPrice = 0
      }

      return (this.totalPrice = newPrice)
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}

.modal {
  text-align: left;
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 40.75rem;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.modal::-webkit-scrollbar {
  display: none;
}

.modal-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 2rem;
}

.buttons {
  display: flex;
  align-items: center;
}

.buttons-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
}

.mail-icon {
  margin-right: 0.625rem;
}

@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
</style>
